import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function';
import { bucketsKeys } from '../../cache-keys/bucketsKeys';

export function useBucketApplications(bucketID: string) {
  const api = useAPI();

  return useQuery({
    queryKey: [bucketsKeys.bucketApplications(bucketID)],
    queryFn: queryFunction(
      ace_api.findBucketApplications(api),
      ({ queryKey: [{ id }] }) => ({ BucketID: id }),
    ),
    enabled: bucketID !== '' && api.token !== '',
  });
}
